import './BlockList.css';
import { User } from '../../Header/elements/User/User';
import { Soldier } from './Soldier/Soldier';

export const BlockList = () => {
    return (
        <div className="block-list">
            <div className="block-list__header">
                <h2 className="block-list__title">Черное</h2>
                <span className="block-list__combined-shape">x2</span>
                <svg className="block-list__leadership-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                    <g fill="#F1F1F1" opacity=".6">
                        <path d="M14 13.92H2a2 2 0 1 1 0-4h12a2 2 0 1 1 0 4z" />
                        <circle cx="8" cy="4.587" r="2.667" />
                        <circle cx="13" cy="6.92" r="1.667" />
                        <circle cx="3" cy="6.92" r="1.667" />
                        <path d="M10 13.92H6a2.667 2.667 0 0 1 0-5.333h4a2.667 2.667 0 0 1 0 5.333z" />
                    </g>
                </svg>
                <span className="block-list__leadership">17</span>
                <span className="block-list__add-user">1413</span>
            </div>
            <Soldier />
            <Soldier />
            <Soldier />
            <Soldier />
        </div>
    );
};
